import { useContext } from 'react';
import { WidgetEventsContext, } from '../context/WidgetEventsContext';
/**
 * Hook to access widget events context
 * Must be used within a WidgetEventsProvider
 */
export const useWidgetEvents = () => {
    const context = useContext(WidgetEventsContext);
    if (context === undefined) {
        throw new Error('useWidgetEvents must be used within a WidgetEventsProvider');
    }
    return context;
};
//# sourceMappingURL=useWidgetEvents.js.map